export const FROM_COURSES_FOR_PERSONNEL_DIALOG =
  'FROM_COURSES_FOR_PERSONNEL_DIALOG';
export const FROM_ADD_EDIT_COURSE_RECORD_PANEL =
  'FROM_ADD_EDIT_COURSE_RECORD_PANEL';

export default {
  FROM_COURSES_FOR_PERSONNEL_DIALOG,
  FROM_ADD_EDIT_COURSE_RECORD_PANEL
};
